// src/utils/addressToSogniUsername.js
import axios from 'axios';

const usernameCache = {};

/**
 * Takes an Ethereum address (0x...) and returns a Sogni username (string) if found,
 * otherwise returns null or empty string.
 */
export async function addressToSogniUsername(address) {
  if (!address) return null;

  // If cached, return immediately
  if (usernameCache[address.toLowerCase()]) {
    return usernameCache[address.toLowerCase()];
  }

  try {
    const resp = await axios.get(
      `https://api.sogni.ai/v1/account/address-to-username?address=${address}`
    );
    if (resp.data?.status === 'success' && resp.data.data?.username) {
      const user = resp.data.data.username;
      // Cache the result
      usernameCache[address.toLowerCase()] = user;
      return user;
    }
    // If not found
    return null;
  } catch (err) {
    console.warn(`Failed to fetch Sogni username for ${address}:`, err);
    return null;
  }
}
